import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=00c9e9fc&scoped=true&"
import script from "./CreateFolder.vue?vue&type=script&lang=ts&"
export * from "./CreateFolder.vue?vue&type=script&lang=ts&"
import style0 from "./CreateFolder.vue?vue&type=style&index=0&id=00c9e9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c9e9fc",
  null
  
)

export default component.exports